const MAX_BYTES = 700_000;

export function compressImage(file, maxSide = 900) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No pude leer el archivo"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Archivo no es una imagen válida"));
      img.onload = () => {
        let { width: w, height: h } = img;
        if (w > h && w > maxSide) { h = Math.round(h * maxSide / w); w = maxSide; }
        else if (h > maxSide) { w = Math.round(w * maxSide / h); h = maxSide; }
        const c = document.createElement("canvas");
        c.width = w; c.height = h;
        c.getContext("2d").drawImage(img, 0, 0, w, h);
        let q = 0.82;
        let url = c.toDataURL("image/jpeg", q);
        while (url.length > MAX_BYTES && q > 0.4) { q -= 0.1; url = c.toDataURL("image/jpeg", q); }
        if (url.length > MAX_BYTES) return reject(new Error("Imagen muy pesada"));
        resolve(url);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
